enum FORM_NAMES {
  holderName = 'name',
}

export {FORM_NAMES};
